<template>
  <a-popover :title="$t('ENTER_COMPLAINT')" :visible="modalVisible">
    <div slot="content">
      <a-textarea class="complainTextArea" style="resize:none" v-model="complaintText" :placeholder="$t('COMPLAINT_TEXT')" :rows="4"/>
<!--      <br>-->
<!--      <br>-->
      <div class="complainBtnBlock">
        <a-button class="complainCloseBtn"  @click="this.toggleComplain">
          {{ $t('CLOSE') }}
        </a-button>
        <a-button class="complainSendBtn"  @click="sendComplaintModal()" type="primary">
          {{ $t('SEND') }}
        </a-button>
      </div>
    </div>
    <span style="color: red;" @click="this.toggleComplain">{{ $t('TO_COMPLAIN') }}</span>
  </a-popover>
</template>

<script>
import {sendComplaint} from "@/services/api-v1";
import {mapActions} from "vuex";

export default {
  name: 'ComplainModal',
  props: {
    itemId: Number,
    entityType: String
  },
  data() {
    return {
      complaintText: ''
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.$store.state.app.complainModal
      }
    }
  },
  methods: {
    ...mapActions({
      toggleComplain: 'toggleComplainModal'
    }),

    async sendComplaintModal() {
      if (this.complaintText) {
        const res = await sendComplaint({
          content: this.complaintText,
          id: `f${(+new Date()).toString(16)}`,
          complaint_entity_id: this.itemId,
          complaint_entity_type: this.entityType
        })
        if (res.statusText === 'Created') {
          this.complaintText = ''
          this.$notification.open({
            message: this.$t('COMPLAINT_SENT'),
            description: this.$t('THANKS_FOR_THE_COMPLAINT'),
          });
        }
      }

      this.toggleComplain()
      console.log(this.modalVisible)
    },
  }
}
</script>

<style lang="scss">
.ant-popover {
  width: 250px;

  .complainTextArea {
    margin-bottom: 10px;
  }

  .complainBtnBlock {
    display: flex;
    max-width: 100%;
    justify-content: flex-end;

    .complainSendBtn {
      margin-left: 10px;
    }
  }
}

</style>
